<template>
  <div class="second-step">
    <a-form-model :model="spiderParse" style="min-height: 400px">
      <a-collapse v-model="activeKey" expand-icon-position="right">
        <a-collapse-panel key="1" header="解析规则">
          <a-form-model-item label="选择器类型">
            <a-radio-group v-model="spiderParse.spiderParseType">
              <a-radio :value="4"> 智能解析 </a-radio>
              <a-radio :value="1"> xpath解析器 </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="解析规则">
            <a-card
              class="config-card"
              v-for="(item, index) in spiderParse.spiderParseConfig"
              :key="index"
            >
              <div slot="extra" class="card-operate">
                <span @click="handleCopyConfig(item, index)">复制</span>
                <!--                <span  @click="handleAddConfig(index)">添加</span>-->
                <!--                <span v-if="index > 0" @click="handleDeleteConfig(index)">删除</span>-->
              </div>
              <Rule :ruleForm="item" />
            </a-card>
          </a-form-model-item>
        </a-collapse-panel>
      </a-collapse>
    </a-form-model>
  </div>
</template>

<script>
import Rule from './Rule'
import _ from 'lodash'
export default {
  data() {
    return {
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      activeKey: [1, 2, 3]
    }
  },
  props: ['spiderParse'],

  methods: {
    handleCopyConfig(val, index) {
      this.spiderParse.spiderParseConfig.splice(index, 0, _.cloneDeep(val))
    },
    handleAddConfig(index) {
      this.spiderParse.spiderParseConfig.splice(index + 1, 0, {
        urls: ['baid.com'],
        parseId: 'sputniknews_news_parse_id',
        config: [
          {
            name: 'title',
            rule: ''
          },
          {
            name: 'content',
            rule: ''
          },
          {
            name: 'publisher',
            rule: ''
          },
          {
            name: 'publish_time',
            rule: ''
          },
          {
            name: 'keywords',
            rule: ''
          },
          {
            name: 'file',
            rule: ''
          }
        ]
      })
    },
    handleDeleteConfig(index) {
      this.spiderParse.spiderParseConfig.splice(index, 1)
    }
  },
  components: {
    Rule
  }
}
</script>

<style lang="less" scoped>
.second-step {
  margin-bottom: 50px;
}
.config-card {
  margin-bottom: 10px;
  min-height: 300px;
  &::before {
    margin-bottom: 0;
  }
}
.card-operate {
  span {
    margin-left: 20px;
    font-size: 14px;
    cursor: pointer;
    color: #1890ff;
  }
}
</style>
